module.exports = __webpack_public_path__ + "img/E2 Pred Dn.79431e55.png";